import { Provider } from '@angular/core';
import {
  DeleteDependenceUseCase,
  GetByTaskGroupUseCase,
  GetByTaskTemplateUseCase,
} from '@app/application/use-cases/task-dependence';
import { TaskDependenceRepository } from '@app/domain';
import { TaskDependenceRepositoryImpl } from '../repositories';

export const TASK_DEPENDENCE_PROVIDERS: Provider[] = [
  //Repositories
  {
    provide: TaskDependenceRepository,
    useClass: TaskDependenceRepositoryImpl,
  },
  {
    provide: GetByTaskGroupUseCase,
    useFactory: (taskDependenceRepo: TaskDependenceRepository) =>
      new GetByTaskGroupUseCase(taskDependenceRepo),
    deps: [TaskDependenceRepository],
  },
  {
    provide: GetByTaskTemplateUseCase,
    useFactory: (taskDependenceRepo: TaskDependenceRepository) =>
      new GetByTaskTemplateUseCase(taskDependenceRepo),
    deps: [TaskDependenceRepository],
  },
  {
    provide: DeleteDependenceUseCase,
    useFactory: (taskDependenceRepo: TaskDependenceRepository) =>
      new DeleteDependenceUseCase(taskDependenceRepo),
    deps: [TaskDependenceRepository],
  },
];
